function AJAX_REQUEST(url, errElem, errMessage) {
  this.url = url;
  this.errElem = errElem;
  this.errMessage = errMessage;
}

AJAX_REQUEST.prototype.getData = function (successCallback) {
  $.ajax(this.url, {
    dataType: 'json',
    type: 'GET',
    error: function(xhr, status, errorThrown) {
      this.errElem.html(this.errMessage);
    },
    success: successCallback
  });
}
